// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntd[data-v-f138028a] \n{\n\tvertical-align: middle;\n}\n.table th[data-v-f138028a] {\n\tvertical-align: middle;\n}\n", ""]);
// Exports
module.exports = exports;
